module.exports = __webpack_public_path__ + "static/media/icon_filter.b0ab1da6.svg";